export default __webpack_public_path__ + "static/media/thumb.cd247f4f.png";